/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import Form from '@organisms/Form';

const BlogDaySelector = (props) => {
  const [dayNumber, setDayNumber] = React.useState(1);

  const placeholder = '- Choose a day -';
  const days = [
    {
      id: 1,
      label: 'Day 1',
    },
    {
      id: 2,
      label: 'Day 2',
    },
    {
      id: 3,
      label: 'Day 3',
    },
    {
      id: 4,
      label: 'Day 4',
    },
    {
      id: 5,
      label: 'Day 5',
    },
    {
      id: 6,
      label: 'Day 6',
    },
    {
      id: 7,
      label: 'Day 7',
    },
    {
      id: 8,
      label: 'Day 8',
    },
    {
      id: 9,
      label: 'Day 9',
    },
    {
      id: 10,
      label: 'Day 10',
    },
    {
      id: 11,
      label: 'Day 11',
    },
    {
      id: 12,
      label: 'Day 12',
    },
    {
      id: 13,
      label: 'Day 13',
    },
    {
      id: 14,
      label: 'Day 14',
    },
  ];

  const usedDays = props.eventBlogsList?.map((item) => item.content.dayNumber);

  return (
    <Form.Item {...props}>
      <Select placeholder={placeholder} style={{ width: '100%' }} onSelect={setDayNumber} value={dayNumber}>
        {days.map(({ label, id }) => (
          <Select.Option key={id} value={id} disabled={usedDays?.includes(id)}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default BlogDaySelector;
